import { render, staticRenderFns } from "./addfirware.vue?vue&type=template&id=01ca1e75&scoped=true"
import script from "./addfirware.vue?vue&type=script&lang=js"
export * from "./addfirware.vue?vue&type=script&lang=js"
import style0 from "./addfirware.vue?vue&type=style&index=0&id=01ca1e75&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ca1e75",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-manage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01ca1e75')) {
      api.createRecord('01ca1e75', component.options)
    } else {
      api.reload('01ca1e75', component.options)
    }
    module.hot.accept("./addfirware.vue?vue&type=template&id=01ca1e75&scoped=true", function () {
      api.rerender('01ca1e75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/firmware/addfirware.vue"
export default component.exports